export const createCancelAndHoldAutomationEvent = (cancelTime) => {
    return { cancelTime, type: 'cancelAndHold' };
};
//# sourceMappingURL=create-cancel-and-hold-automation-event.js.map